const pending = new WeakSet();

export function requestPasswordReset(socket, userId, password) {
    if (pending.has(socket)) return Promise.reject(new Error('RESET_PENDING'));
    pending.add(socket);
    return new Promise((resolve, reject) => {
        socket.timeout(15000).emit('.change_password', { user_id: userId, new_password: password }, (error, result) => {
            pending.delete(socket);
            if (error || !result?.success) reject(new Error('RESET_FAILED'));
            else resolve();
        });
    });
}
